import * as api from '../api';

export class Http {
    static getUrlParameter(name) {
        const url = window.location.href;
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);

        // eslint-disable-next-line no-useless-escape
        name = name.replace(/[\[\]]/g, '\\$&');

        if (!results) return null;

        if (!results[2]) return '';

        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    static getUrlParameters() {
        const queryString = decodeURIComponent(window.location.search.replace(/.*?\?/, ''));
        const params = {};

        if (queryString.length) {
            const keyValPairs = queryString.split('&');

            keyValPairs.forEach((pair) => {
                const key = pair.split('=')[0];

                if (!key.length) {
                    return;
                }
                params[key] = pair.split('=')[1];
            });
        }

        return params;
    }

    static redirect(d: api.PaymentInfoRedirect) {
        if (d.method.toLowerCase() === 'get' && d.requestParameters.length === 0) {
            window.location.href = d.url;
        }
        else {
            const form: HTMLFormElement = window.document.createElement('form');

            form.method = d.method;
            form.action = d.url;

            for (let i = 0; i < d.requestParameters.length; i++) {
                const p = d.requestParameters[i];
                const input = window.document.createElement('input');
                input.value = p.paramValue;
                input.name = p.paramName;
                input.type = 'hidden';
                form.appendChild(input);
            }

            window.document.body.appendChild(form);

            // Wait for DOM issues.
            setTimeout(() => {
                form.submit();
            }, 1000);
        }
    }

    static hiddenFrameWithPost(d: api.PaymentInfoRedirect) {
        let html = '<html><body onload="console.log(\'fff\');document.form.submit()"><form name="form" action="' + d.url + '" method="post">';

        if (d.requestParameters) {
            for (let i = 0; i < d.requestParameters.length; i++) {
                html += '<input type="hidden" name="' + d.requestParameters[i].paramName + '" value="' + d.requestParameters[i].paramValue + '">';
            }
        }

        html += '</form></body></html>';

        const iframe: HTMLIFrameElement = window.document.createElement('iframe');
        iframe.style.visibility = 'hidden';

        window.document.body.appendChild(iframe);

        let fDoc = iframe.contentDocument || iframe.contentWindow?.document;
        if (fDoc) {
            fDoc.write(html);
            fDoc.close();
        }
    }
}
